import { useFlags } from "launchdarkly-react-client-sdk";

/**
 * Whether private coaching is rolled out here: the LaunchDarkly flag
 * `chat-ai-coaching`, separate from the assistant's own
 * `chat-ai-assistant`. Off — or not yet defined — hides coaching everywhere
 * in the app: the chat panel offers none, and Settings → Compono Assist has
 * no Private coaching section. On, each organisation's own switch
 * (`coaching_enabled`, on by default) decides, as the chat service enforces.
 *
 * Like the assistant's flag, it is the browser's gate only; the chat service
 * never reads LaunchDarkly.
 */
export const usePrivateCoachingFlag = (): boolean => {
  const { chatAiCoaching } = useFlags();
  return Boolean(chatAiCoaching);
};
